export const environment = {
  production: false,
  apiUrl: 'https://fcgfqnviz6.execute-api.us-east-1.amazonaws.com/Prod/api/', //se cambia por instrucciones de Fer

  //aws s3
  bucket: 's3siquede',
  BasePath: 'Dev',

  //Login Azure
  redirectAplicationAzure: '',
  scopesAzure: 'api://1f4e3786-7836-47fc-aeda-b8f318ae1f66/Auth.AD',
  clientIdAzure: 'ae72665d-5d83-48a1-8479-5981a332eccc',
  authorityAzure:
    'https://login.microsoftonline.com/6d88d07c-1672-4d16-ab8c-3af2ef736fe7',
  meAzure: 'https://graph.microsoft.com/v1.0/me',
  nombreEntorno: "Desarrollo",
  microServiceS3UploadUrl: "https://bfpip44cf9.execute-api.us-east-1.amazonaws.com/Prod",


};
